import React, { FC, useMemo } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Navigation } from "swiper/modules";
import { ReactComponent as ArrowLeftIcon } from "src/assets/icons/arrow-left-circle.svg";
import { useGetGalleryQuery } from "src/redux/api";
import { getImageUrl } from "src/constants/urls";
import { SCREEN_BREAKPOINTS } from "src/constants/screenBreakpoints";

export const GallerySlider: FC = () => {
  const { data, isLoading } = useGetGalleryQuery();

  const items = useMemo(() => {
    if (!data) return [];
    return [...data].sort((a, b) => a.order - b.order);
  }, [data]);

  if (isLoading) return null;
  if (!items.length) return null;

  return (
    <div className="flex flex-col gap-4 xl:gap-8">
      <h3 className="text-center text-white-base font-black text-lg xl:text-32">
        Нам довіряють
      </h3>

      <div className="flex items-center gap-2 xl:gap-4 w-full">
        <button
          type="button"
          aria-label="Попередній"
          className="gallery-slider__prev shrink-0 transition-opacity hover:opacity-80 disabled:opacity-40"
        >
          <ArrowLeftIcon className="w-8 h-8 xl:w-14 xl:h-14" />
        </button>

        <Swiper
          className="w-full"
          modules={[Navigation]}
          navigation={{
            prevEl: ".gallery-slider__prev",
            nextEl: ".gallery-slider__next",
          }}
          slidesPerView="auto"
          breakpoints={{
            0: { spaceBetween: 8 },
            [SCREEN_BREAKPOINTS.XL]: { spaceBetween: 16 },
          }}
        >
          {items.map((item) => (
            <SwiperSlide key={item.id} style={{ width: "auto" }}>
              <div className="flex items-center justify-center w-[72px] h-[72px] xl:w-[120px] xl:h-[120px] bg-white-base rounded-xl xl:rounded-2xl p-2 xl:p-3">
                <img
                  src={getImageUrl(item.image)}
                  alt={item.title}
                  className="max-h-full max-w-full object-contain"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <button
          type="button"
          aria-label="Наступний"
          className="gallery-slider__next shrink-0 transition-opacity hover:opacity-80 disabled:opacity-40"
        >
          <ArrowLeftIcon className="w-8 h-8 xl:w-14 xl:h-14 rotate-180" />
        </button>
      </div>
    </div>
  );
};
